

//TEST
/*
<script src="https://www.gstatic.com/firebasejs/4.8.0/firebase.js"></script>
<script>
  // Initialize Firebase
  var config = {
    apiKey: "AIzaSyBu8PSQxQfjW--oSDuPKmSJIbHhElU-Xxk",
    authDomain: "ovs-presenzadirigenti-prod.firebaseapp.com",
    databaseURL: "https://ovs-presenzadirigenti-prod.firebaseio.com",
    projectId: "ovs-presenzadirigenti-prod",
    storageBucket: "ovs-presenzadirigenti-prod.appspot.com",
    messagingSenderId: "212079463216"
  };
  firebase.initializeApp(config);
</script>
*/

export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyB76o3-Pa7wJ1_XccXMFeP-A-d4U2xs-aE",
  authDomain: "login.weekplanning.gcp.ovs.it",
  databaseURL: "https://ovs-presenzadirigenti-prod.firebaseio.com",
  projectId: "ovs-presenzadirigenti-prod",
  storageBucket: "ovs-presenzadirigenti-prod.appspot.com",
  messagingSenderId: "724668623187"
};

//PRODUZIONE
/*
export const FIREBASE_CONFIG = {
};*/



// WEBPACK FOOTER //
// ./src/app/app.firebase.config.ts